export default __webpack_public_path__ + "static/media/SnakeGame.5e91a131.png";